import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col rounded-xl border border-gray-200 overflow-hidden bg-white" };
const _hoisted_2 = { class: "flex items-center px-4 py-2.5 bg-gray-50 border-b border-gray-200" };
const _hoisted_3 = { class: "w-56 shrink-0 text-xs font-semibold text-gray-500 uppercase tracking-wide" };
const _hoisted_4 = { class: "w-28 shrink-0 text-xs font-semibold text-gray-500 uppercase tracking-wide" };
const _hoisted_5 = { class: "w-24 shrink-0 text-xs font-semibold text-gray-500 uppercase tracking-wide" };
const _hoisted_6 = { class: "ml-auto text-xs font-semibold text-gray-500 uppercase tracking-wide" };
const _hoisted_7 = { class: "flex items-center px-4 py-3 bg-gray-50 border-t border-gray-200" };
const _hoisted_8 = ["disabled"];
import ChargeTableRow from './ChargeTableRow.vue';
import ChargeEditorRow from './ChargeEditorRow.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChargeTemplateTable',
    props: {
        templates: {},
        editingId: {},
        isSaving: { type: Boolean }
    },
    emits: ["edit", "delete", "save", "cancel-edit", "add-row"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("services.charges.labels.name")), 1),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("services.charges.labels.type")), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("services.charges.labels.amount")), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("services.charges.labels.actions")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.templates, (template) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: template.id
                    }, [
                        (__props.editingId === template.id)
                            ? (_openBlock(), _createBlock(ChargeEditorRow, {
                                key: 0,
                                template: template,
                                "is-saving": __props.isSaving,
                                onSave: _cache[0] || (_cache[0] = (dto) => _ctx.$emit('save', dto)),
                                onCancel: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('cancel-edit')))
                            }, null, 8, ["template", "is-saving"]))
                            : (_openBlock(), _createBlock(ChargeTableRow, {
                                key: 1,
                                template: template,
                                onEdit: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('edit', $event))),
                                onDelete: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('delete', $event)))
                            }, null, 8, ["template"]))
                    ]));
                }), 128)),
                (__props.editingId === 'new')
                    ? (_openBlock(), _createBlock(ChargeEditorRow, {
                        key: 0,
                        "is-saving": __props.isSaving,
                        onSave: _cache[4] || (_cache[4] = (dto) => _ctx.$emit('save', dto)),
                        onCancel: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('cancel-edit')))
                    }, null, 8, ["is-saving"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center gap-1.5 text-sm text-egreen font-medium hover:underline transition-colors",
                        disabled: __props.editingId !== null,
                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$emit('add-row')))
                    }, [
                        _cache[7] || (_cache[7] = _createElementVNode("svg", {
                            class: "w-4 h-4",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "stroke-width": "2",
                            stroke: "currentColor"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M12 4.5v15m7.5-7.5h-15"
                            })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("services.charges.actions.add_charge")), 1)
                    ], 8, _hoisted_8)
                ])
            ]));
        };
    }
});
